let Backbone = require("backbone");
let BillItemModel = require("../model/BillItemModel.js");

let main = function (Backbone, BillItemModel) {
    return Backbone.Collection.extend({
        model: BillItemModel,

        getToConfirmItemCollection: function () {
            if (!this.toConfirmItemCollection) {
                this.toConfirmItemCollection = new Backbone.Collection(this.where({status: "ToConfirm"}));
            } else {
                this.toConfirmItemCollection.reset(this.where({status: "ToConfirm"}));
            }
            return this.toConfirmItemCollection;
        },

        getMaxPriority: function () {
            if (this.at(0)) {
                return this.at(0).get("priority");
            } else {
                return 0;
            }
        },
        comparator: 'priority'
    });
};

let exportedValue = main(Backbone, BillItemModel);
module.exports = exportedValue;



// WEBPACK FOOTER //
// ./src/collection/BillItemCollection.js